<template>
  <div v-if="isOpen" class="modal fade show" aria-labelledby="addNewCardTitle"
       style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">{{ props.form?.project_account_name }}</h1>
              <div class="d-flex align-items-center gap-2">
                <span v-if="props.form.unit_name" class="badge bg-info fs-6">
                  {{ props.form.unit_name }}
                </span>
                <button
                    @click="toggleModal"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0">

        <!-- Nav Tabs -->
        <ul v-if="form.project_type === 'task' && form.id" class="nav nav-tabs px-2" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'period' }" @click="activeTab = 'period'" href="javascript:void(0)">
              Period Breakdown
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'team' }" @click="activeTab = 'team'" href="javascript:void(0)">
              Team Member Breakdown
            </a>
          </li>
        </ul>

        <div class="pb-2 pt-1">
          <!-- form -->
          <form @submit.prevent="handleSubmit">
            <div class="row gy-2 px-2">
              <div v-if="form.project_type === 'task'" class="col-3">
                <label class="form-label" for="item">Qty/Hour</label>
                <div>
                  <input
                      type="text"
                      class="form-control"
                      v-model="props.form.quantity"
                  >
                </div>
              </div>
              <div v-if="form.project_type === 'task'" class="col-3"></div>
              <div v-else class="col-3">
                <label class="form-label" for="quantity">Qty</label>
                <div>
                  <input
                      type="text"
                      name="quantity"
                      class="form-control"
                      v-model="props.form.quantity"
                      @keyup="calculateAmount"
                  >
                </div>
              </div>
              <div v-if="form.project_type === 'task'" class="col-3"></div>
              <div v-else class="col-3">
                <label class="form-label" for="rate">Rate</label>
                <div>
                  <input
                      type="text"
                      name="rate"
                      class="form-control"
                      v-model="props.form.rate"
                      @keyup="calculateAmount"
                  >
                </div>
              </div>
              <div v-if="form.project_type !== 'task'" class="col-3">
                <label class="form-label" for="item">Amount</label>
                <div>
                  <input
                      type="text"
                      class="form-control"
                      v-model="props.form.amount"
                      @keyup="clearRate"
                  >
                </div>
              </div>
              <div class="col-3">
                <span v-if="isFillVisible && activeTab === 'period'">
                  <button class="btn btn-sm btn-info mt-2" type="button" @click="computeFill">
                    Fill
                  </button>
                </span>
                &nbsp;
                <span v-if="isAttributeVisible">
                  <button class="btn btn-sm btn-info mt-2" type="button" @click="computeAttribute">
                    Attribute
                  </button>
               </span>
              </div>

              <!-- Period Breakdown Table -->
              <div v-if="activeTab === 'period'" class="col-12">
                <div v-if="form.project_type === 'task'" class="col-10 m-auto mt-2">
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Period Breakdown</th>
                          <th class="text-end w-150">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(breakdown, key) in props.form.breakdown" :key="key">
                          <td class="fw-bold">{{ key }}</td>
                          <td>
                            <input
                              type="text"
                              class="form-control form-control-sm text-end"
                              v-model="props.form.breakdown_qty[key]"
                              @input="sumQuantity"
                              placeholder="Qty"
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="table-secondary fw-bold">
                          <td>TOTAL</td>
                          <td class="text-end px-1">{{ totalQty }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div v-else class="table-responsive mt-2">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Period Breakdown</th>
                        <th class="text-end w-150">Qty</th>
                        <th class="text-end w-150">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(breakdown, key) in props.form.breakdown" :key="key">
                        <td class="fw-bold">{{ key }}</td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.breakdown_qty[key]"
                            @input="sumQuantity"
                            placeholder="Qty"
                          >
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.breakdown[key]"
                            @input="sumAmount"
                            placeholder="Amount"
                          >
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-secondary fw-bold">
                        <td>TOTAL</td>
                        <td class="text-end px-1">{{ totalQty }}</td>
                        <td class="text-end px-1">{{ totalAmount }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <!-- Team Member Breakdown Table -->
              <div v-if="activeTab === 'team'" class="col-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Team Member</th>
                        <th>Role</th>
                        <th class="text-end w-150">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="team in props.form.project_teams" :key="team.id">
                        <td class="fw-bold">{{ team.team_member_name }}</td>
                        <td>{{ team.team_role_label }}</td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm text-end"
                            v-model="props.form.team_member_breakdown_qty[team.team_member_id]"
                            @input="sumQuantity"
                            placeholder="Qty"
                          >
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-secondary fw-bold">
                        <td colspan="2">TOTAL</td>
                        <td class="text-end px-1">{{ totalQty }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <hr class="mt-2">
              <button :disabled="loading" type="submit"
                      class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button @click.prevent="resetBreakdown" class="btn btn-outline-secondary  me-1 mt-1 waves-effect waves-float waves-light">
                Reset Breakdown
              </button>
              <button @click.prevent="toggleModal" class="btn btn-outline-secondary mt-1 waves-effect">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, ref, watchEffect} from "vue";

const props = defineProps({
  form: Object,
});
const emit = defineEmits(['onCloseModal', 'onBusinessGeneralSave', 'onResetBreakdown'])

let isOpen = ref(false);
let loading = ref(false);
let isAttributeVisible = ref(true);
let isFillVisible = ref(true);
let activeTab = ref('period');

const totalQty = ref(0);
const totalAmount = ref(0);

watchEffect(() => {
  let sumQty = 0;
  let sumAmt = 0;

  if (activeTab.value === 'period') {
    Object.values(props.form.breakdown_qty || {}).forEach(qty => {
      sumQty += Number(qty || 0);
    });
    Object.values(props.form.breakdown || {}).forEach(amount => {
      sumAmt += Number(amount || 0);
    });
  } else {
    Object.values(props.form.team_member_breakdown_qty || {}).forEach(qty => {
      sumQty += Number(qty || 0);
    });
    Object.values(props.form.team_member_breakdown || {}).forEach(amount => {
      sumAmt += Number(amount || 0);
    });
  }

  totalQty.value = Math.round(sumQty);
  totalAmount.value = Math.round(sumAmt);
});

const toggleModal = () => {
  if (isOpen.value) {
    emit("onCloseModal")
  }
  
  if (!isOpen.value) {
    activeTab.value = 'period';
    if (!props.form.team_member_breakdown) props.form.team_member_breakdown = {};
    if (!props.form.team_member_breakdown_qty) props.form.team_member_breakdown_qty = {};
  }
  
  isOpen.value = !isOpen.value
}
const setActiveTab = (tab) => {
  activeTab.value = tab;
}
defineExpose({toggleModal, setActiveTab, activeTab});

const handleSubmit = () => {
  emit('onBusinessGeneralSave', props.form.id);
}

const calculateAmount = () => {
  hideFill();
  props.form.amount = props.form.rate * props.form.quantity;
}

const clearRate = () => {
  hideFill();
  props.form.rate = 0;
  props.form.quantity = 0;
}

const sumAmount = () => {
  hideAttribute();
  props.form.amount = totalAmount.value;
}

const sumQuantity = () => {
  props.form.quantity = totalQty.value;
};

const hideFill = () => {
  isAttributeVisible.value = true;
  isFillVisible.value = props.form.amount <= 0;
}

const hideAttribute = (value) => {
  isFillVisible.value = true;
  isAttributeVisible.value = value <= 0;
}

const computeFill = () => {
  props.form.fill_type = 'fill';

  const value = Object.values(props.form.breakdown)[0] || 0;

  Object.keys(props.form.breakdown).map(key => {
    props.form.breakdown[key] = value;
  });

  props.form.amount = totalAmount.value;
  props.form.rate = 0;
  props.form.quantity = 0;
}

const computeAttribute = () => {
  if (activeTab.value !== 'period') {
    // Team Breakdown Attribute
    const teams = props.form.project_teams || [];
    if (teams.length < 1) return;

    const valAmt = (props.form.amount / teams.length).toFixed(2);
    const valQty = (props.form.quantity / teams.length).toFixed(2);
    
    teams.forEach(t => {
      props.form.team_member_breakdown[t.team_member_id] = valAmt;
      props.form.team_member_breakdown_qty[t.team_member_id] = valQty;
    });
    return;
  }

  // Period Logic
  if (props.form.project_type !== 'task') {
    props.form.fill_type = 'attribute';
    const breakdownKeys = Object.keys(props.form.breakdown);
    const value = (props.form.amount / breakdownKeys.length).toFixed(2);

    breakdownKeys.forEach(key => {
      props.form.breakdown[key] = value;
    });
  }

  const keysQty = Object.keys(props.form.breakdown_qty);
  if (!keysQty.length) return;

  const valueQty = (props.form.quantity / keysQty.length).toFixed(2);
  keysQty.forEach(key => {
    props.form.breakdown_qty[key] = valueQty;
  });
}

const resetBreakdown = () => {
  emit('onResetBreakdown', props.form.budget_master_id)
}
</script>

<style scoped>
.w-150 {
  width: 150px;
}
</style>